import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { toDollars } from "../../../helpers/currencies";
import { VehiclePricingRequestAggregations } from "../../../types/VehiclePricingRequest";

const PricingRequestAverages = ({
  aggregations,
}: {
  aggregations: VehiclePricingRequestAggregations;
}) => {
  return (
    <Stack spacing={0}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          width: "fit-content",
          alignItems: "flex-end",
        }}
      >
        <Typography variant="titleMedium" color="onSurface.main">
          Avg Onroad: {toDollars(aggregations.avgOnroadPrice, 0)}
        </Typography>
        <Typography variant="titleMedium" color="onSurface.main">
          Avg Discount: {toDollars(aggregations.avgDiscount, 0)}
        </Typography>
        <Typography variant="titleMedium" color="onSurface.main">
          Max Discount: {toDollars(aggregations.maxDiscount, 0)}
        </Typography>
        <Typography variant="titleMedium" color="onSurface.main">
          Min Discount: {toDollars(aggregations.minDiscount, 0)}
        </Typography>
      </Box>
    </Stack>
  );
};

export default PricingRequestAverages;
